/**
 * Seekers Bookings Routes
 *
 * This route serves shows interview requests, (EONC) bookings, and completed contracts for seekers/parents
 *
 *
 * Guards:
 * - requireSeeker: Ensures user is a parent (authentication)
 * - checkPremiumParentRegistration: Ensures premium parents have completed address registration
 * - checkCorporateOnboarding: Ensures corporate parents have completed onboarding
 */
import { RouteConfig } from 'vue-router';
import { requireSeeker } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration, checkCorporateOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '../guards/helpers';

const bookingsRoutes: RouteConfig[] = [
  {
    path: '/bookings',
    name: 'seeker-bookings',
    component: () => import('@/apps/bookings/SeekerBookings.vue'),
    beforeEnter: combineGuards([requireSeeker, checkCorporateOnboarding, checkPremiumParentRegistration]),
  },
  {
    path: '/bookings/booking/confirmed/:contractId',
    name: 'seeker-booking-confirmed',
    component: () => import('@/apps/bookings/booking/confirmed/SeekerBookingConfirmed.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireSeeker, checkPremiumParentRegistration]),
  },
  {
    path: '/bookings/booking/accepted/:contractId',
    name: 'seeker-booking-accepted',
    component: () => import('@/apps/bookings/booking/accepted/SeekerBookingAccepted.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireSeeker, checkPremiumParentRegistration]),
  },
  {
    path: '/bookings/interview/accepted/:contractId',
    name: 'seeker-interview-accepted',
    component: () => import('@/apps/bookings/interview/accepted/SeekerInterviewAccepted.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireSeeker, checkPremiumParentRegistration]),
  },
  {
    path: '/bookings/:contractId',
    name: 'seeker-contract',
    component: () => import('@/apps/bookings/[contractId].vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireSeeker, checkPremiumParentRegistration]),
  },
];

export default bookingsRoutes;
